module.exports = __webpack_public_path__ + "img/74.2d92082f.jpg";